import React from "react";

export const Settings = ({
  isAuthorized,
  shopDomain,
  setShopDomain,
  syncProducts,
  toggleSyncProducts,
}) => {
  return (
    <>
      <div className="col-xs-12">
        <div className="newInputFileldOuter">
          <div className="newInputLabel">
            Shop url<span className="setting-require">*</span>
          </div>
          <div className="setting-input-outer">
            <input
              name="shop_domain"
              type="text"
              value={shopDomain}
              onChange={(e) => setShopDomain(e.target.value)}
              autoComplete="off"
              className="newInputField"
              disabled={isAuthorized}
            />
          </div>
        </div>
      </div>
      <div className="col-xs-12">
        <div className="setting-custom-switch product-active pull-left m-t-10">
          <label className="setting-switch pull-left no-margin">
            <input
              type="checkbox"
              className="setting-custom-switch-input"
              name="sync_products"
              autoComplete="off"
              checked={syncProducts}
              onChange={toggleSyncProducts}
            />
            <span className="setting-slider"></span>
          </label>
          <span id="membership_lable" className="m-l-15 radioLabel">
            Sync product stock
          </span>
        </div>
      </div>
    </>
  );
};
